import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return { message: e?.message || "Ocurrió un error. Intenta de nuevo.", fields: {} };
  if (typeof d === "string") return { message: d, fields: {} };
  if (Array.isArray(d)) return { message: d.map((x) => x?.msg || JSON.stringify(x)).join(" "), fields: {} };
  if (typeof d === "object") return { message: d.message || "Revisa los datos", fields: d.fields || {} };
  return { message: String(d), fields: {} };
}
